import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { StoryProvider, useStory, STEPS } from './context/StoryContext';
import { Toaster } from './components/ui/sonner';

// Screens
import LandingScreen from './components/screens/LandingScreen';
import ProtagonistTypeScreen from './components/screens/ProtagonistTypeScreen';
import NameScreen from './components/screens/NameScreen';
import CoverScreen from './components/screens/CoverScreen';
import PreviewScreen from './components/screens/PreviewScreen';
import FormScreen from './components/screens/FormScreen';
import SuccessScreen from './components/screens/SuccessScreen';
import LoadingScreen from './components/screens/LoadingScreen';
import PrivacyPolicyScreen from './components/screens/PrivacyPolicyScreen';
import TermsOfUseScreen from './components/screens/TermsOfUseScreen';

function StoryFlow() {
  const { currentStep, isLoading, uiTexts } = useStory();

  if (isLoading) {
    return <LoadingScreen message={uiTexts?.loading || 'Preparant el teu conte màgic...'} />;
  }

  switch (currentStep) {
    case STEPS.LANDING:
      return <LandingScreen />;
    case STEPS.PROTAGONIST_TYPE:
      return <ProtagonistTypeScreen />;
    case STEPS.NAME:
      return <NameScreen />;
    case STEPS.COVER:
      return <CoverScreen />;
    case STEPS.PREVIEW:
      return <PreviewScreen />;
    case STEPS.FORM:
      return <FormScreen />;
    case STEPS.SUCCESS:
      return <SuccessScreen />;
    default:
      return <LandingScreen />;
  }
}

function App() {
  return (
    <BrowserRouter>
      <StoryProvider>
        <div className="app-container">
          <Routes>
            <Route path="/" element={<StoryFlow />} />
            <Route path="/politica-privacitat" element={<PrivacyPolicyScreen />} />
            <Route path="/condicions-us" element={<TermsOfUseScreen />} />
          </Routes>
          <Toaster position="top-center" />
        </div>
      </StoryProvider>
    </BrowserRouter>
  );
}

export default App;
